import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = {
        position: Number,
        slides: Array,
        lengths: Array,
    }

    static targets = [
        'current',
        'next',
    ]

    transitionToNextPosition() {
        this.currentTarget.classList.add('out');
        this.currentTarget.classList.remove('initial');
        this.nextTarget.classList.add('in');
        this.nextTarget.classList.remove('hidden');
        this.element.classList.remove(`underline-${ this.positionValue == 0 ? this.lengthsValue[this.slidesValue.length - 1] : this.lengthsValue[this.positionValue - 1] }`);
        this.element.classList.add(`underline-${ this.lengthsValue[this.positionValue] }`);

        setTimeout(() => {
            this.intialHTML();
        }, 300);
    }

    async currentCopy() {
        if (this.positionValue < this.slidesValue.length) {
            return this.slidesValue[this.positionValue];
        } else {
            return this.slidesValue[0];
        }
    }

    async nextCopy() {
        if (this.positionValue < this.slidesValue.length - 1) {
            return this.slidesValue[this.positionValue + 1];
        } else {
            return this.slidesValue[0];
        }
    }

    async intialHTML() {
        this.currentTarget.innerHTML = await this.currentCopy();
        this.nextTarget.innerHTML = await this.nextCopy();
        this.element.classList.remove()
        this.currentTarget.classList.add('initial');
        this.currentTarget.classList.remove('out');
        this.nextTarget.classList.add('hidden');
        this.nextTarget.classList.remove('in');

        setTimeout(() => {
            this.nextSlide();
        }, 1000);
    }

    nextSlide() {
        if (this.positionValue < this.slidesValue.length - 1) {
            this.positionValue = this.positionValue  + 1;
        } else {
            this.positionValue = 0;
        }
    }

    positionValueChanged() {
        if(this.positionValue == undefined) {
            return null;
        }

        this.transitionToNextPosition();
    }
}
